module.exports = __webpack_public_path__ + "img/contactUs-2.95424a72.png";